import sdkProvider from "../sdkProvider";

const getCustomerId = async () => {
  const identitySdk = await sdkProvider("identity");

  return identitySdk.customer.customerId();
};

export default getCustomerId;
